/**
 * 生成各种id
 * @author: vergilzhou
 * @version: 1.0.0
 * @date: 2016/09/19
 * @form:/qidian/src/wpa/src/util/ids.js
 */
const win = window;
const doc = win.document;
const QID_PREFIX = 'QD.';

const base36 = function (num) {
  return num.toString(36);
};

/**
 * 将字符串转换成一个数字
 * 同一个字符串的输入转换结果是固定的
 * 通常用于将随机字符串转换成数字，然后计算概率
 * @param {string} str input string.
 * @return {number} hash number.
 */
const hash = function (str) {
  let hash = 1;
  if (str) {
    let charCode = 0;
    hash = 0;
    for (let i = str.length - 1; i >= 0; i--) {
      charCode = str.charCodeAt(i);
      // eslint-disable-next-line no-mixed-operators
      hash = (hash << 6 & 268435455) + charCode + (charCode << 14);
      charCode = hash & 266338304;
      /* eslint eqeqeq: 0 */
      hash = charCode != 0 ? hash ^ charCode >> 21 : hash;
    }
  }
  return hash;
};

/**
 * 生成随机字符串
 * @return {number}
 */
const random = function () {
  let random;
  // https://zh.wikipedia.org/wiki/2147483647
  // 2147483647 === 1111111111111111111111111111111
  try {
    const arr = new Uint32Array(1);
    // https://developer.mozilla.org/en-US/docs/Web/API/RandomSource/getRandomValues
    win.crypto.getRandomValues(arr);
    random = arr[0] & 2147483647;
  } catch (b) {
    random = Math.floor(Math.random() * 2147483648);
  }
  return random;
};

const createClickId = function (needPrefix) {
  const uaAndCookieAndRefAndHref = win.navigator.userAgent
        + (doc.cookie ? doc.cookie : '')
        + (doc.referrer ? doc.referrer : '')
        + win.location.href;
    // 样例
  const result = `${base36(random() ^ hash(uaAndCookieAndRefAndHref) & 2147483647)}.${base36(random())}.${base36(+new Date())}`;
  return needPrefix ? QID_PREFIX + result : result;
};
export { createClickId };
